/* eslint-disable */
import { Component, Input, ViewChild } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';

@Component({
  selector: 'md-tooltip',
  template: require('./tooltip.component.html')
})
export class TooltipComponent {
  @Input() text;
  @Input() tooltipTitle;
  @Input() tooltipText;
  @Input() hasToolTip;
  @Input() hasToolTipIcon;
  @Input() id;
  @Input() labelClass;
  @Input() subText;
  @Input() opensModal = false;
  @Input() isResidence = false;
  @Input() iconAltText = 'Info';
  @ViewChild('focusItem') focusItem;

  constructor(modal: ModalService) { this.modal = modal; }

  ngOnInit() {
    this.uid = `${this.id}_tooltip`;
  }

  tooltipModal() {
    this.modal.itinModal(this.tooltipTitle, this.tooltipText, false);
  }

  mouseOver(event, data) {
    const toolTips = document.querySelectorAll('.tooltip');
    for (var i = toolTips.length - 1; i >= 0; i--) {
      toolTips[i].style.display = 'none';
    }
    document.getElementById(this.uid).style.display = 'block';
    document.getElementById(this.uid).style.left = !this.hasToolTipIcon
      ? `${event.clientX - 20}px`
      : '';

      if (this.focusItem) {
        setTimeout(() => {
          this.focusItem.nativeElement.focus();
        }, 0);
      }
    this.isTooltipOpen = true;
  }

  closeTooltip(event) {
    document.getElementById(this.uid).style.display = 'none';
  }

  onFocusOut(event){
    const triggerElement = event.target;
    const tooltipElement = document.getElementById(this.uid);
    const relatedTarget = event.relatedTarget;

    if(!relatedTarget ||
      (!tooltipElement.contains(relatedTarget) &&
      !triggerElement.contains(relatedTarget))){
        this.closeTooltip(event);
    }
  }

  get tooltipClass() {
    let classes = (this.labelClass || '').split(' ');
    classes.push('tooltip-underline');
    return classes.join(' ');
  }

  get preText() {
    return this.text.split(this.subText)[0];
  }

  get postText() {
    return this.text.split(this.subText)[1];
  }
}
